import { _defineProperty } from "./index13.js";
import WorkerWrapper from "./index228.js";
import { SuperMitt } from "./index229.js";
import { wait } from "@project-rouge/rg-core";
import { wrap } from "comlink";
var OffscreenAbstractSite = class {
	constructor() {
		_defineProperty(this, "_worker", void 0);
		_defineProperty(this, "_comm", void 0);
		_defineProperty(this, "queue", []);
		_defineProperty(this, "emitter", new SuperMitt());
		_defineProperty(this, "getBase64Img", async (props, log = false) => {
			log && console.log("getBase64Img start");
			this.queue.push(props);
			while (!await this.comm.isReady()) await wait(.5);
			while (this.queue[0] !== props) await this.emitter.wait("onChange");
			const resultBlob = await this.comm.render(props);
			const result = URL.createObjectURL(resultBlob);
			log && console.log("getBase64Img done");
			this.queue.shift();
			this.emitter.emit("onChange");
			return result;
		});
	}
	get worker() {
		if (!this._worker) this._worker = new WorkerWrapper();
		return this._worker;
	}
	get comm() {
		if (!this._comm) this._comm = wrap(this.worker);
		return this._comm;
	}
};
const offscreenAbstractSite = new OffscreenAbstractSite();
export { offscreenAbstractSite };

//# sourceMappingURL=index230.js.map